import { ChangeDetectionStrategy, Component, computed, inject, input, output, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkantElementsModule } from '@markant/elements-angular';
import { TranslocoService } from '@jsverse/transloco';
import { MarkantSelectOption } from '@markant-platform/shared/util-helpers';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { toSignal } from '@angular/core/rxjs-interop';
import { IsoCountryService } from '@markant-platform/shared/util-locale';
import { map } from 'rxjs';

@Component({
  selector: 'markant-platform-ui-country-select',
  standalone: true,
  imports: [CommonModule, MarkantElementsModule, ReactiveFormsModule],
  templateUrl: './ui-country-select.component.html',
  styleUrl: './ui-country-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiCountrySelectComponent {
  label = input<string>();
  control = input<FormControl<string>>(new FormControl('', { nonNullable: true }));
  name = input<string>('');
  placeholder = input<string>('');
  error = input<string>('');
  helper = input<string>('');
  searchPlaceholder = input<string>('');
  searchable = input<boolean>(true);
  outlined = input<boolean>(false);
  multiselect = input<boolean>(false);
  truncateOptions = input<boolean>(true);
  required = input<boolean>(false);
  showLabelHint = input<boolean>(false);
  readonly = input<boolean>(false);

  valueChanged = output<string>();

  translocoService = inject(TranslocoService);
  isoCountryService = inject(IsoCountryService);

  private activeLanguage = this.translocoService.getActiveLang()?.split('-')[0];

  langChang = toSignal(this.translocoService.langChanges$.pipe(map(lang => lang.split('-')[0])), {
    initialValue: this.activeLanguage,
  });

  countries: Signal<MarkantSelectOption[]> = computed(() => {
    return this.isoCountryService.getSelectCountriesNames(this.langChang());
  });
}
